module.exports = __webpack_public_path__ + "Banner_ABOUT_ATP.jpg?2475d2a8a27ad7b69dee02422ffc2e5e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/Banner_ABOUT_ATP.jpg
// module id = 159
// module chunks = 0